import React from 'react';
import './loading-spinner.css';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner-container">
      <div
        className="loading-spinner"
        role="status"
        aria-label="Loading"
        aria-live="polite"
      >
        <span className="loading-dot" />
        <span className="loading-dot" />
        <span className="loading-dot" />
      </div>
    </div>
  );
};

export default LoadingSpinner;
